import { render, staticRenderFns } from "./UserAuthorization.vue?vue&type=template&id=e182009a&"
import script from "./UserAuthorization.vue?vue&type=script&lang=js&"
export * from "./UserAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e182009a')) {
      api.createRecord('e182009a', component.options)
    } else {
      api.reload('e182009a', component.options)
    }
    module.hot.accept("./UserAuthorization.vue?vue&type=template&id=e182009a&", function () {
      api.rerender('e182009a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/UserAuthorization.vue"
export default component.exports